
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

@Component({
  name: 'catalog-product-slider',
  components: {
    ...ServiceContainer().getComponents(),
    Swiper,
    Navigation,
  },
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: true}) readonly products: Array<object>;

  private productSwiper: Swiper | null = null;

  private created(): void {
    this.$nextTick(() => {
      this.productSwiper = new Swiper(`#related-slider .swiper`, {
        modules: [Navigation],
        slidesPerView: 2,
        spaceBetween: 10,
        roundLengths: true,
        navigation: {
          nextEl: `#related-slider .swiper__button.--next`,
          prevEl: `#related-slider .swiper__button.--prev`,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      });
    });
  }
}
